import * as types from './siteProfileActionType';

// Site Profile Actions
export const fetchSiteProfileRequest = (siteID) => ({
    type: types.FETCH_SITE_PROFILE_REQUEST,
    payload: siteID
});

export const fetchSiteProfileSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_SUCCESS,
    payload: data
});

export const fetchSiteProfileFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_FAILURE,
    payload: error
});

// Site Coverage Hours Actions
export const fetchSiteCoverageHoursRequest = (siteID) => ({
    type: types.FETCH_SITE_COVERAGE_HOURS_REQUEST,
    payload: siteID
});

export const fetchSiteCoverageHoursSuccess = (data) => ({
    type: types.FETCH_SITE_COVERAGE_HOURS_SUCCESS,
    payload: data
});

export const fetchSiteCoverageHoursFailure = (error) => ({
    type: types.FETCH_SITE_COVERAGE_HOURS_FAILURE,
    payload: error
});

// Site Associated Radiologists Actions
export const fetchSiteAssociatedRadsRequest = (siteId) => ({
    type: types.FETCH_SITE_ASSOCIATED_RADS_REQUEST,
    payload: siteId
});

export const fetchSiteAssociatedRadsSuccess = (data) => ({
    type: types.FETCH_SITE_ASSOCIATED_RADS_SUCCESS,
    payload: data
});

export const fetchSiteAssociatedRadsFailure = (error) => ({
    type: types.FETCH_SITE_ASSOCIATED_RADS_FAILURE,
    payload: error
});

// Site Calendar Demand Actions
export const fetchSiteCalendarDemandRequest = (payload) => ({
    type: types.FETCH_SITE_CALENDAR_DEMAND_REQUEST,
    payload
});

export const fetchSiteCalendarDemandSuccess = (data, request) => ({
    type: types.FETCH_SITE_CALENDAR_DEMAND_SUCCESS,
    payload: data,
    request
});

export const fetchSiteCalendarDemandFailure = (error, request) => ({
    type: types.FETCH_SITE_CALENDAR_DEMAND_FAILURE,
    payload: error,
    request
});

// Site Calendar Demand By Date Actions
export const fetchSiteCalendarDemandByDateRequest = (payload) => ({
    type: types.FETCH_SITE_CALENDAR_DEMAND_BY_DATE_REQUEST,
    payload
});

// Site RADS Demand Schedule Actions
export const fetchSiteRadsDemandScheduleRequest = (payload) => ({
    type: types.FETCH_SITE_RADS_DEMAND_SCHEDULE_REQUEST,
    payload
});

export const fetchSiteRadsDemandScheduleSuccess = (data, request) => ({
    type: types.FETCH_SITE_RADS_DEMAND_SCHEDULE_SUCCESS,
    payload: data,
    request
});

export const fetchSiteRadsDemandScheduleFailure = (error, request) => ({
    type: types.FETCH_SITE_RADS_DEMAND_SCHEDULE_FAILURE,
    payload: error,
    request
});

export const fetchSiteCalendarDemandByDateSuccess = (data, request) => ({
    type: types.FETCH_SITE_CALENDAR_DEMAND_BY_DATE_SUCCESS,
    payload: data,
    request
});

export const fetchSiteCalendarDemandByDateFailure = (error, request) => ({
    type: types.FETCH_SITE_CALENDAR_DEMAND_BY_DATE_FAILURE,
    payload: error,
    request
});

// Site Associated RAD Metrics Actions
export const fetchSiteAssociatedRadMetricsRequest = (siteID) => ({
    type: types.FETCH_SITE_ASSOCIATED_RAD_METRICS_REQUEST,
    payload: siteID
});

export const fetchSiteAssociatedRadMetricsSuccess = (data) => ({
    type: types.FETCH_SITE_ASSOCIATED_RAD_METRICS_SUCCESS,
    payload: data
});

export const fetchSiteAssociatedRadMetricsFailure = (error) => ({
    type: types.FETCH_SITE_ASSOCIATED_RAD_METRICS_FAILURE,
    payload: error
});

// Site RAD Metrics Dropdown Actions
export const fetchSiteRadMetricsDropdownRequest = (payload) => ({
    type: types.FETCH_SITE_RAD_METRICS_DROPDOWN_REQUEST,
    payload: payload
});

export const fetchSiteRadMetricsDropdownSuccess = (data) => ({
    type: types.FETCH_SITE_RAD_METRICS_DROPDOWN_SUCCESS,
    payload: data
});

export const fetchSiteRadMetricsDropdownFailure = (error) => ({
    type: types.FETCH_SITE_RAD_METRICS_DROPDOWN_FAILURE,
    payload: error
});

// Export Site Associated RAD Metrics Actions
export const exportSiteAssociatedRadMetricsRequest = (payload) => ({
    type: types.EXPORT_SITE_ASSOCIATED_RAD_METRICS_REQUEST,
    payload: payload
});

export const exportSiteAssociatedRadMetricsSuccess = (data) => ({
    type: types.EXPORT_SITE_ASSOCIATED_RAD_METRICS_SUCCESS,
    payload: data
});

export const exportSiteAssociatedRadMetricsFailure = (error) => ({
    type: types.EXPORT_SITE_ASSOCIATED_RAD_METRICS_FAILURE,
    payload: error
});

// Site Matrix Child Tables Actions
export const fetchSiteMatrixChildTablesRequest = (payload) => ({
    type: types.FETCH_SITE_MATRIX_CHILD_TABLES_REQUEST,
    payload: payload
});

export const fetchSiteMatrixChildTablesSuccess = (data) => ({
    type: types.FETCH_SITE_MATRIX_CHILD_TABLES_SUCCESS,
    payload: data
});

export const fetchSiteMatrixChildTablesFailure = (error) => ({
    type: types.FETCH_SITE_MATRIX_CHILD_TABLES_FAILURE,
    payload: error
});

// Site Profile Demand By Hours Chart Actions
export const fetchSiteProfileDemandByHoursChartRequest = (payload) => ({
    type: types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_REQUEST,
    payload: payload
});

export const fetchSiteProfileDemandByHoursChartSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_SUCCESS,
    payload: data
});

export const fetchSiteProfileDemandByHoursChartFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_FAILURE,
    payload: error
});

// Site Profile Volume By Priority Chart Actions
export const fetchSiteProfileVolumeByPriorityChartRequest = (payload) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_REQUEST,
    payload: payload
});

export const fetchSiteProfileVolumeByPriorityChartSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_SUCCESS,
    payload: data
});

export const fetchSiteProfileVolumeByPriorityChartFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_FAILURE,
    payload: error
});
// Site Profile Volume By Modality Chart Actions
export const fetchSiteProfileVolumeByModalityChartRequest = (payload) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_REQUEST,
    payload: payload
});

export const fetchSiteProfileVolumeByModalityChartSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_SUCCESS,
    payload: data
});

export const fetchSiteProfileVolumeByModalityChartFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_FAILURE,
    payload: error
});

// Associate RAD to Site Actions
export const associateRadToSiteRequest = (payload) => ({
    type: types.ASSOCIATE_RAD_TO_SITE_REQUEST,
    payload
});

export const associateRadToSiteSuccess = (data) => ({
    type: types.ASSOCIATE_RAD_TO_SITE_SUCCESS,
    payload: data
});

export const associateRadToSiteFailure = (error) => ({
    type: types.ASSOCIATE_RAD_TO_SITE_FAILURE,
    payload: error
});

// Disassociate RAD from Site Actions
export const disassociateRadFromSiteRequest = (payload) => ({
    type: types.DISASSOCIATE_RAD_FROM_SITE_REQUEST,
    payload
});

export const disassociateRadFromSiteSuccess = (data) => ({
    type: types.DISASSOCIATE_RAD_FROM_SITE_SUCCESS,
    payload: data
});

export const disassociateRadFromSiteFailure = (error) => ({
    type: types.DISASSOCIATE_RAD_FROM_SITE_FAILURE,
    payload: error
});

// RADs Not Associated To Site (dropdown) Actions
export const fetchRadsNotAssociatedToSiteRequest = (siteId) => ({
    type: types.FETCH_RADS_NOT_ASSOCIATED_TO_SITE_REQUEST,
    payload: siteId
});

export const fetchRadsNotAssociatedToSiteSuccess = (data) => ({
    type: types.FETCH_RADS_NOT_ASSOCIATED_TO_SITE_SUCCESS,
    payload: data
});

export const fetchRadsNotAssociatedToSiteFailure = (error) => ({
    type: types.FETCH_RADS_NOT_ASSOCIATED_TO_SITE_FAILURE,
    payload: error
});

// Site Profile Metrics Dropdown Actions
export const fetchSiteProfileMetricsDropdownRequest = () => ({
    type: types.FETCH_SITE_PROFILE_METRICS_DROPDOWN_REQUEST
});

export const fetchSiteProfileMetricsDropdownSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_METRICS_DROPDOWN_SUCCESS,
    payload: data
});

export const fetchSiteProfileMetricsDropdownFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_METRICS_DROPDOWN_FAILURE,
    payload: error
});

// Site Profile Demand By Hours Chart Details (Filtered) Actions
export const fetchSiteProfileDemandByHoursChartDetailsRequest = (payload) => ({
    type: types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_REQUEST,
    payload: payload
});

export const fetchSiteProfileDemandByHoursChartDetailsSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_SUCCESS,
    payload: data
});

export const fetchSiteProfileDemandByHoursChartDetailsFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_DEMAND_BY_HOURS_CHART_DETAILS_FAILURE,
    payload: error
});

// Site Profile Volume By Modality Chart Details (Filtered) Actions
export const fetchSiteProfileVolumeByModalityChartDetailsRequest = (payload) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_REQUEST,
    payload: payload
});

export const fetchSiteProfileVolumeByModalityChartDetailsSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_SUCCESS,
    payload: data
});

export const fetchSiteProfileVolumeByModalityChartDetailsFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_MODALITY_CHART_DETAILS_FAILURE,
    payload: error
});

// Site Profile Volume By Priority Chart Details (Filtered) Actions
export const fetchSiteProfileVolumeByPriorityChartDetailsRequest = (payload) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_REQUEST,
    payload: payload
});

export const fetchSiteProfileVolumeByPriorityChartDetailsSuccess = (data) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_SUCCESS,
    payload: data
});

export const fetchSiteProfileVolumeByPriorityChartDetailsFailure = (error) => ({
    type: types.FETCH_SITE_PROFILE_VOLUME_BY_PRIORITY_CHART_DETAILS_FAILURE,
    payload: error
});

// Site Rad Assignment Notes
export const fetchSiteRadNotesRequest = (payload) => ({
    type: types.FETCH_SITE_RAD_NOTES_REQUEST,
    payload,
});
export const fetchSiteRadNotesSuccess = (data) => ({
    type: types.FETCH_SITE_RAD_NOTES_SUCCESS,
    payload: data,
});
export const fetchSiteRadNotesFailure = (error) => ({
    type: types.FETCH_SITE_RAD_NOTES_FAILURE,
    payload: error,
});

export const fetchSiteRadAllNotesRequest = (payload) => ({
    type: types.FETCH_SITE_RAD_ALL_NOTES_REQUEST,
    payload,
});
export const fetchSiteRadAllNotesSuccess = (data) => ({
    type: types.FETCH_SITE_RAD_ALL_NOTES_SUCCESS,
    payload: data,
});
export const fetchSiteRadAllNotesFailure = (error) => ({
    type: types.FETCH_SITE_RAD_ALL_NOTES_FAILURE,
    payload: error,
});

export const addSiteRadNoteRequest = (payload) => ({
    type: types.ADD_SITE_RAD_NOTE_REQUEST,
    payload,
});
export const addSiteRadNoteSuccess = () => ({
    type: types.ADD_SITE_RAD_NOTE_SUCCESS,
});
export const addSiteRadNoteFailure = (error) => ({
    type: types.ADD_SITE_RAD_NOTE_FAILURE,
    payload: error,
});

export const clearSiteRadNotes = () => ({
    type: types.CLEAR_SITE_RAD_NOTES,
});
export const clearSiteRadAllNotes = () => ({
    type: types.CLEAR_SITE_RAD_ALL_NOTES,
});
export const resetAddSiteRadNoteSuccess = () => ({
    type: types.RESET_ADD_SITE_RAD_NOTE_SUCCESS,
});
export const fetchSiteWorklistsRequest = (payload) => ({ type: types.FETCH_SITE_WORKLISTS_REQUEST, payload });
export const resetSiteWorklistContext = () => ({ type: types.RESET_SITE_WORKLIST_CONTEXT });
export const resetSiteScheduleContext = () => ({ type: types.RESET_SITE_SCHEDULE_CONTEXT });
export const resetSiteCalendarContext = () => ({ type: types.RESET_SITE_CALENDAR_CONTEXT });
